const collectionPrinciples = [
  {
    title: 'Complete start',
    label: 'Snel spelen',
    copy: 'Begin met sets waarin paddles, ballen en netopties logisch bij elkaar passen voor thuis, gymles of clubavond.'
  },
  {
    title: 'Paddles per speler',
    label: 'Betere keuze',
    copy: 'Kies op niveau, speelgevoel en gebruikssituatie. Zo vind je sneller een paddle die past bij je eerste lessen of volgende stap.'
  },
  {
    title: 'Clubs en scholen',
    label: 'Pakketadvies',
    copy: 'Voor groepen kijken we naar spelersaantal, locatie, netten, ballen en accessoires voordat we een pakket voorstellen.'
  },
  {
    title: 'Duidelijke service',
    label: 'Vooraf geregeld',
    copy: 'Je ziet vooraf wat de richtprijs is, hoe updates werken en welke servicepagina’s gelden zodra bestellen open gaat.'
  }
];

export function SupplierMatrix() {
  return (
    <section className="section servicePromiseSection" id="service">
      <p className="eyebrow">Waarom ProPickleball.nl</p>
      <h2>Een webshop voor spelers, gezinnen, clubs en scholen die goed willen starten.</h2>
      <p className="sectionIntro">
        De winkel start met de producten waar beginnende en groeiende spelers het meest om vragen: startersets, paddles, ballen, netten, grips, tassen en clubpakketten.
      </p>
      <div className="supplierGrid">
        {collectionPrinciples.map((item) => (
          <article className="supplierCard" key={item.title}>
            <div className="supplierTop"><strong>{item.title}</strong><span>{item.label}</span></div>
            <p>{item.copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
